import { key } from './constants';
import { Nonce } from './types';

export const get = (): Nonce | undefined => {
  const nonceString = window.localStorage.getItem(key);
  return nonceString ? JSON.parse(nonceString) : undefined;
};
